export const LS_BUFFER_KEY = 'buffer';

export const LOG_ENDPOINT_LIVE = 'https://sub49.tobit.com/v2.1/Log/web';
export const LOG_ENDPOINT_DEV = 'https://sub49.tobit.com/dev/v2.1/Log/web';
